module.exports = __webpack_public_path__ + "img/company_historybg.d8d61863.jpg";